import Requester from "./Requester";

interface CreateDTO {
    name: string
}

type Options = { signal?: AbortSignal };


export function getAttributes(limit: number = 10, page: number = 1, search: string | null = null, options) {
    const requester = new Requester();

    return requester.get(requester.getUrl('api/attributes', [
        { name: 'limit', value: limit },
        { name: 'page', value: page },
        { name: 'search', value: search },
    ]), {
        signal: options.signal
    })
}

export type MergePayload = {
    attribute_id: number;
    from: number[];          // список ID значений, которые сливаем
    to?: number;             // ID целевого значения
    to_value?: string;       // или строковое значение для создания/поиска цели
    dry_run?: boolean;       // показать, что будет сделано
    delete_old?: boolean;    // удалить старые значения после слияния
};

// Получить значения атрибута с подсчётом использования (и поиском)
export function getAttributeValues(
    attributeId: number,
    search: string | null = null,
    options: Options = {}
) {
    const requester = new Requester();

    return requester.get(
        requester.getUrl(`api/attributes/${attributeId}/values`, [
            { name: "search", value: search },
        ]),
        { signal: options.signal }
    );
}

// Слить значения атрибута (боевой запуск)
export function mergeAttributeValues(payload: MergePayload, options: Options = {}) {
    const requester = new Requester();

    return requester.post(
        requester.getUrl("api/attribute-values/merge"),
        payload,
        { signal: options.signal }
    );
}

// Предпросмотр слияния (dry-run)
export function previewMergeAttributeValues(
    payload: Omit<MergePayload, "dry_run">,
    options: Options = {}
) {
    const requester = new Requester();

    return requester.post(
        requester.getUrl("api/attribute-values/merge"),
        { ...payload, dry_run: true },
        { signal: options.signal }
    );
}


export function search(id) {
    const requester = new Requester();

    return requester.get(requester.getUrl(`api/attributes/${id}/search`))
}

export function getAttribute(id: number) {
    const requester = new Requester();

    return requester.get(requester.getUrl(`api/attributes/${id}`))
}

export function destroy(id) {
    const requester = new Requester();

    return requester.delete(requester.getUrl(`api/attributes/${id}`))
}

export function create(values: CreateDTO) {
    const requester = new Requester();

    return requester.post(requester.getUrl(`api/attributes`), values)
}

export default {
    create,
    getAttributes,
    getAttribute,
    destroy,
    search,
    getAttributeValues,
    mergeAttributeValues,
    previewMergeAttributeValues,
}